<template>
    <div style="position: relative">
        <wp_user_info_banner :user_info="user_name"
                             :back_img="backImg"
                             :icon="head_icon"
                             font_color="#fff"
                             v-if="this.$store.getters.isLogin===true"
                             :style="{height: banner_height}"
        >
            <div slot="points" style="visibility: collapse; height: 0px"></div>
            <div slot="user_info" style="position: relative; margin-top: -10px;font-size: 25px">
                <div v-if="user_name">
                    {{user_name}}<span style="font-size: 20px">({{$store.state.username?$store.state.username.toUpperCase():''}})</span>
                </div>
                <div v-else>
                    {{$store.state.username?$store.state.username.toUpperCase():''}}
                </div>
            </div>
        </wp_user_info_banner>

        <van-button v-if="$config.project != 'hm'" size="small" type="danger" plain
                    style=" position: absolute; top: 15px; right: 10px;"
                    @click="logout"
        >退出登录
        </van-button>

    </div>
</template>

<script>
    import Wp_user_info_banner from "../waps_ui/wp_user_info_banner";
    export default {
        name: "Wp_user_banner",
        components: {Wp_user_info_banner},
        data() {
            return {
                // backImg: 'http://bpic.588ku.com/back_pic/04/60/31/27586c8f25335b5.jpg!/fh/300/quality/90/unsharp/true/compress/true',
                // backImg: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1567058215664&di=89bbaeb3385843e87cec770f5e026110&imgtype=0&src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F32d8ee71d2693ac3c543de2b58b33243c59593a546bdc-2FuU5L_fw658',
                // backImg: require('../assets/back_img.png')
                backImg: require('../../assets/back_img.png'),

                banner_height: '60px',

                head_icon: "https://www.shandw.com/mobile/images/phdavatar.png",

                user_name: "",
            }
        },
        created() {

            let isLogin = this.$store.getters.isLogin;
            this.$log("isLogin = " + isLogin);
            if (isLogin !== true) {
                this.$bus.$emit('toLogin', '登录吧,牛宝宝');
            }
        },

        methods: {
            logout() {

                if (this.$common.gloabl_wx_openid) {
                    this.$wx.miniProgram.getEnv(res => {

                        if (res.miniprogram) {
                            //判断是否弹出登录界面
                            this.$store.commit('logout');
                            //弹出小程序中的登录界面
                            this.$router.push("mini_login")
                        }else{
                            this.$store.commit('logout');
                            this.$emit('reload');
                            window.location.replace("/index.html")
                        }
                    });

                } else {
                    // this.$goto('home');
                    this.$store.commit('logout');
                    this.$emit('reload');
                    window.location.replace("/index.html");
                    // this.$router.push("select")

                }

            }
        }
    }
</script>

<style scoped>

</style>